import { Alert, Button, Modal } from 'antd';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { IBlockedModalProps } from './types';

const BlockedModal: FC<IBlockedModalProps> = ({ open, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={[
        <Button
          key="ok-button"
          shape="round"
          type="primary"
          style={{ width: 113 }}
          onClick={onClose}
          block
        >
          OK
        </Button>
      ]}
    >
      <Alert
        message={t('common.account_is_blocked')}
        description={t('common.account_is_blocked_message')}
        type="error"
        style={{ backgroundColor: 'transparent', border: 'none' }}
        showIcon
      />
    </Modal>
  );
};

export default BlockedModal;
